module.exports = __webpack_public_path__ + "img/coin1.81c2240b.png";